var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable prettier/prettier */
import React from 'react';
import { Modal, message } from 'antd';
import ImagePreview from './../ImagePreview';
export var CommonModalType;
(function (CommonModalType) {
    CommonModalType[CommonModalType["Graphic"] = 0] = "Graphic";
    CommonModalType[CommonModalType["Message"] = 1] = "Message";
    CommonModalType[CommonModalType["ImagePreview"] = 2] = "ImagePreview";
})(CommonModalType || (CommonModalType = {}));
export var CommonModalCbType;
(function (CommonModalCbType) {
    CommonModalCbType[CommonModalCbType["WebBrowser"] = 5] = "WebBrowser";
    CommonModalCbType[CommonModalCbType["MainWindow"] = 6] = "MainWindow";
    CommonModalCbType[CommonModalCbType["NewWindow"] = 7] = "NewWindow";
})(CommonModalCbType || (CommonModalCbType = {}));
export var CommonModalMessageLevel;
(function (CommonModalMessageLevel) {
    CommonModalMessageLevel[CommonModalMessageLevel["Success"] = 0] = "Success";
    CommonModalMessageLevel[CommonModalMessageLevel["Warn"] = 1] = "Warn";
    CommonModalMessageLevel[CommonModalMessageLevel["Failed"] = 2] = "Failed";
})(CommonModalMessageLevel || (CommonModalMessageLevel = {}));
// 图 + 文 + 按钮形式按钮
function CommonModal0(props) {
    var footer = function () { return (React.createElement("div", null,
        React.createElement("div", { className: "btn primary", style: {
                width: 262,
                lineHeight: '42px',
                textAlign: 'center',
                margin: '0 auto 10px auto',
                color: '#fff',
                cursor: 'pointer',
            }, onClick: function () {
                props.onOk && props.onOk();
            } }, props.onOkText))); };
    return (React.createElement("div", { style: {
            minHeight: 250,
            display: 'flex',
            flexDirection: 'column',
        } },
        React.createElement("div", { style: {
                padding: '40px 40px 30px 40px',
                textAlign: 'center',
            } },
            React.createElement("img", { style: {
                    width: 186,
                    height: 138,
                    marginBottom: 15,
                }, alt: "", src: props.data && props.data.icon }),
            React.createElement("p", { style: {
                    color: '#232930',
                    fontSize: 16,
                    fontWeight: 500,
                    textAlign: 'left',
                } }, props.data && props.data.content)),
        footer()));
}
// 全局alert
function CommonModal1(props) {
    if (props.data && props.data.level === CommonModalMessageLevel.Success) {
        message.success({
            className: 'me-common-modal-message',
            content: props.data && props.data.text,
        });
    }
    if (props.data && props.data.level === CommonModalMessageLevel.Warn) {
        message.warn({
            className: 'me-common-modal-message',
            content: props.data && props.data.text,
        });
    }
    if (props.data && props.data.level === CommonModalMessageLevel.Failed) {
        message.error({
            className: 'me-common-modal-message',
            content: props.data && props.data.text,
        });
    }
    return null;
    // return (
    //     <div
    //         style={{
    //             position: 'fixed',
    //             top: 0,
    //             width: 100,
    //             height: 100,
    //             background: 'red',
    //             zIndex: 10000,
    //         }}
    //     >
    //         1111
    //     </div>
    // );
    // return null;
}
export default function CommonModal(props) {
    var type = props.type, visible = props.visible, _a = props.width, width = _a === void 0 ? 340 : _a, _b = props.height, height = _b === void 0 ? 'auto' : _b, title = props.title, modalClassName = props.modalClassName, onCancelType = props.onCancelType, onOkType = props.onOkType, onCancel = props.onCancel, onOk = props.onOk;
    // 全局message
    if (type === CommonModalType.Message) {
        return CommonModal1(props);
    }
    else if (type === CommonModalType.ImagePreview) {
        return React.createElement(ImagePreview, __assign({}, props));
    }
    return (React.createElement(Modal, { className: "me-common-modal " + (modalClassName || ''), onCancel: onCancel, width: width, visible: visible, bodyStyle: {
            padding: 0,
        }, title: title, footer: null }, type === CommonModalType.Graphic ? React.createElement(CommonModal0, __assign({}, props)) : null));
}
//# sourceMappingURL=index.js.map